<div class="inline-block">
  <div class="relative-left banner-lotto-wrap">
    <app-logo-lotto></app-logo-lotto>
  </div>
    <app-jackpot></app-jackpot>
</div>
